import { denormalize } from "normalizr";

import { receivable } from "../../../api/schema";

export default ids => state => {
  try {
    const items = ids || [];
    const denormalized = denormalize(
      { items },
      { items: [receivable] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
